// Generated by scripts/discover.mjs. Don't edit: add or rename a file instead (CLAUDE.md).

/** What every screen needs at once, per live language: each is its own chunk. */
export const BASE_COPY = {
  en: () => import("./copy-base-en.gen.ts").then((m) => m.default),
  da: () => import("./copy-base-da.gen.ts").then((m) => m.default),
} as const;
